export default angular.module('gazelle.bundles.users', [
  // gzUserPanel,
]).name;



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/bundles/users.module.js